export const calculateAdditionalPregnancyWeight = ({
	weighBeforePregnancy = '',
	actualWeight = '',
}) => {
	const before = Number(weighBeforePregnancy);

	const actual = Number(actualWeight);

	if (!before || !actual) {
		return '';
	}

	return String(actual - before);
};
